import styled from "styled-components";

import { PackageSwitcherContent } from "../../PackageSwitcher/PackageSwitcher.styled";

export const PackageSwitcherErrorContent = styled(PackageSwitcherContent)`
    align-items: center;
    justify-content: center;
    padding: 60px 24px;
`;

export const PackageSwitcherErrorImage = styled.img`
    width: 330px;
`;
